
export const fetchModulesRoutes = routeFiles => {
  const routes = routeFiles.keys().map(key => {
    const path = key.replace('./', '');
    const entries = path.split('/');
    const module = entries.shift();

    return routeFiles(`./${module}/routes.js`).default;
  });

  return routes;
};

/**
 * Open a new window with pdf
 */
export function openPdf(response, type = 'application/pdf') {
  const file = new Blob([response], { type });
  if (
    navigator.appVersion.toString().indexOf('.NET') > 0 ||
    navigator.appVersion.toString().indexOf('Edge') > 0
  ) {
    const extension = type.split('/')[1];
    window.navigator.msSaveBlob(
      file,
      `${URL.createObjectURL(file)}.${extension}`,
    );
  } else {
    const popUp = window.open(URL.createObjectURL(file), '_blank');
    if (!popUp || typeof popUp === 'undefined') {
      alert('Blocked popup'); // eslint-disable-line
    } else {
      popUp.focus();
    }
  }
}

/**
 * Return a object with error
 * @return object
 */
export function catchPdf(response) {
  const decodedString = String.fromCharCode.apply(
    null,
    new Uint8Array(response),
  );
  const obj = JSON.parse(decodedString);
  return obj.message;
}

export function downloadBlobFile(blob, filename, type = 'application/octet-stream') {
  const file = new Blob([blob], { type });
  const url = window.URL.createObjectURL(file);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  link.parentNode.removeChild(link);
  window.URL.revokeObjectURL(url);
}
